import {BaseService} from './Core/BaseService';
import {BaseCachedService} from './Core/BaseCachedService';
// import {Organization} from "../Models/StreamBank/Organization";

class OrganizationService extends BaseCachedService {
    get Url() { return super.Url + this.PageUrl; }
    get ModelName() { return "Organization"; }
    get PrimaryKeyProperty() { return "organizationId"; }
    get TitleProperty() { return "name"; }

    get PageUrl() { return "/organizations"; }
    
    get ItemNamePlural() { return "organizations"; }
    get CreatePermission() { return "create_organization"; }
    get UpdatePermission() { return "update_organization"; }
    
    GetOrganizations() {
        return this.Get();
    }

    GetModel(organizationId) {
        return this.SendRequest(BaseService.GET, organizationId);
    }

    UpdateModel(organization) {
        this.FlushCache();
        return this.SendRequest(BaseService.PUT, organization);
    }

    CreateModel(organization) {
        this.FlushCache();
        return this.SendRequest(BaseService.POST, organization);
    }

    DeleteModel(organizationId) {
        this.FlushCache();
        return this.SendRequest(BaseService.DELETE, organizationId);
    }
}

export const service = new OrganizationService();
